import React from "react";
// import img from '../marketplaceassets/buildimg.png';
import "./HealthcareDelivery.css";

export default function HealthcareDelivery() {
  return (
    <div id="healthcare-delivery" className="outsourcemainclass">
        <div className="overlay"></div>
      <div className="left">
        <h2 className="heading">
          Enhance healthcare delivery with expert consulting.
        </h2>
        <p className="subheading">
        Enhancing Efficiency, Compliance, and Patient Outcomes Through Expert Guidance
        </p>
        <button>Book a Free Consultation</button>
      </div>
      {/* <div className="right">
            <img src={img} alt="error" />
        </div> */}
    </div>
  );
}
